var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-background"},[_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-spinner"}),_c('p',[_vm._v("Loading...")])])])
}]

export { render, staticRenderFns }